import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

export const OPERATORS = {
  openParenthesis: {
    value: '(',
    iconName: 'ba-ParenthesisOpen',
    i18nKey: 'CustomColumnExpressionEditor_Toolbar_LeftParenthesis',
  },
  closeParenthesis: {
    value: ')',
    iconName: 'ba-ParenthesisClose',
    i18nKey: 'CustomColumnExpressionEditor_Toolbar_RightParenthesis',
  },
  add: {
    value: '\u002B',
    iconName: 'ba-CalculatorAddition',
    i18nKey: 'CustomColumnExpressionEditor_Toolbar_Add',
  },
  subtract: {
    value: '\u2212',
    iconName: 'ba-CalculatorSubtract',
    i18nKey: 'CustomColumnExpressionEditor_Toolbar_Subtract',
  },
  multiply: {
    value: '\u00D7',
    iconName: 'ba-CalculatorMultiply',
    i18nKey: 'CustomColumnExpressionEditor_Toolbar_Multiply',
  },
  divide: {
    value: '\u00F7',
    iconName: 'ba-CalculatorDivide',
    i18nKey: 'CustomColumnExpressionEditor_Toolbar_Divide',
  },
};

export class Operator extends React.PureComponent {
  static propTypes = {
    value: PropTypes.oneOf(_.map(_.values(OPERATORS), operator => operator.value)).isRequired,
    className: PropTypes.string,
  };
  static defaultProps = {
    className: 'custom-column-expression-operator',
  };

  render() {
    const { value, className } = this.props;

    return (<div className={className}>{value}</div>);
  }
}
